import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { SEM_EQUIPE_ITEM } from 'components/form'
import { TerritorioViewTabEnum } from 'view/visualizacaoTerritorial/components/list/TerritorioContentSwitch'
import { VisualizacaoTerritorialBuscaFormModel } from 'view/visualizacaoTerritorial/model'
import { VisualizacaoTerritorialBuscaForm } from 'view/visualizacaoTerritorial/VisualizacaoTerritorialBuscaForm'

interface MapaSidebarBuscaContentProps {
  initialValues: VisualizacaoTerritorialBuscaFormModel
  onSubmit: (values: VisualizacaoTerritorialBuscaFormModel) => void
}

export function MapaSidebarBuscaContent(props: Readonly<MapaSidebarBuscaContentProps>) {
  const { initialValues, onSubmit } = props

  const { acesso } = useAcessoLotacaoOrEstagio()

  const isCoordenadorUbs = acesso.perfis?.some((perfil) => perfil?.nome === 'COORDENADOR DA UBS')
  const unidadeSaude = acesso?.unidadeSaude
  const equipe = acesso?.equipe

  const defaultFilter: VisualizacaoTerritorialBuscaFormModel = {
    unidadeSaude: unidadeSaude,
    equipe: isCoordenadorUbs ? null : equipe ?? SEM_EQUIPE_ITEM,
  }

  return (
    <div>
      <VisualizacaoTerritorialBuscaForm
        tabContext={TerritorioViewTabEnum.MAPA_DO_TERRITORIO}
        onSubmit={onSubmit}
        appliedFilter={initialValues}
        defaultFilter={defaultFilter}
      />
    </div>
  )
}
